import { CaseRelatedRequestReplyTypes } from '@/helpers/enum';
import api from '../services/api';
import services from '../services/services';

export default {
  getCaseWithSpecificParty(context, payload) {
    return api[payload.isPega ? 'getPegaCaseWithSpecificParty' : 'getCaseWithSpecificParty'](payload);
  },
  inquiryCase(context, payload) {
    return api.inquiryCase(payload);
  },
  validateCaseRelatedRequest(_context, payload) {
    return services.validateCaseRelatedRequest(payload);
  },
  async saveCaseRelatedRequest(_context, payload) {
    let payloadTo64 = JSON.parse(JSON.stringify(payload));
      if (payloadTo64.data.shouldEncryptFields === undefined || payloadTo64.data.shouldEncryptFields !== 0) {
          let fieldsToEncrypt = await api.getFieldsToEncrypt(payloadTo64.data.requestType);
          if (fieldsToEncrypt != null) {
              const whatToEncode = fieldsToEncrypt.data.split(',');

              for (let i = 0; i < whatToEncode.length; i++) {
                  let location = whatToEncode[i].split('.');
                  if (payloadTo64.data[location[0]] instanceof Array && payloadTo64.data[location[0]].length > 0) {
                      for (let j = 0; j < payloadTo64.data[location[0]].length; j++) {
                          payloadTo64.data[location[0]][j][location[1]] = window.btoa(unescape(encodeURIComponent(payloadTo64.data[location[0]][j][location[1]])));
                      }
                      continue;
                  }

                  if (location.length === 1) {
                      if (payloadTo64.data[whatToEncode[i]])
                          payloadTo64.data[whatToEncode[i]] = window.btoa(unescape(encodeURIComponent(payloadTo64.data[whatToEncode[i]])));
                  }
                  else {
                      if (payloadTo64.data[location[0]][location[1]])
                          payloadTo64.data[location[0]][location[1]] = window.btoa(unescape(encodeURIComponent(payloadTo64.data[location[0]][location[1]])));
                  }
              }
          }
      }
    return api[payload.isPega ? 'savePegaCaseRelatedRequest' : 'saveCaseRelatedRequest'](payloadTo64);
  },
  updateCaseRelatedRequest(_context, payload) {
    return api[payload.isPega ? 'updatePegaCaseRelatedRequest' : 'updateCaseRelatedRequest'](payload).then(() => {
      if (!payload.isPega)
        return api.updateCaseRelatedRequestStatus({
          objectKey: payload.objectKey,
          actionId: CaseRelatedRequestReplyTypes.completeRequestAction,
        });
    });
  },
  updateCaseRelatedProcedure(_context, payload) {
    return api.updateCaseRelatedProcedure(payload);
  },
  getJudicialProcedureExpirationPeriod(_context) {
    return api.getJudicialProcedureExpirationPeriod();
  },
  getCaseRelatedRequests(_context, payload) {
    return api[payload.isPega ? 'getPegaCaseRelatedRequests' : 'getCaseRelatedRequests'](payload.requestObjectKey);
  },
  uploadAttachment(_context, payload) {
    return api.uploadAttachment(payload);
  },
  getAttachment(_context, payload) {
    return api.getAttachment(payload);
  },
  getRequests(_context, payload) {
    return api.getRequests(payload);
  },
  getCases(_context, payload) {
    return api.getCases(payload);
  },
  getJudgements(_context, payload) {
    return api.getJudgements(payload);
  },
  getEmirateJudgements(_context, payload) {
    return api.getEmirateJudgements(payload);
  },
  getPetitionRequestsDetails(_context, payload) {
    return api.getPetitionRequestsDetails(payload);
  },
  getCaseInfo(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCaseInfo' : 'getNajizCaseInfo';
    return api[methodName](payload.objectKey);
  },
  getCaseUpdates(context, payload) {
    const methodName = payload.isPega.toString() == 'true' ? 'getIcmsCaseUpdates' : 'getNajizCaseUpdates';
    return api[methodName](payload.objectKey);
  },
  getCasePartiesDetails(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCasePartiesDetails' : 'getNajizCasePartiesDetails';
    return api[methodName](payload.objectKey);
  },
  getCaseRequestApplicants(context, payload) {
    const methodName = payload.isPega.toString() == 'true' ? 'getIcmsCaseRequestApplicants' : 'getNajizCaseRequestApplicants';
    return api[methodName](payload.objectKey);
  },
  getCaseRequestApplicantsByJudgement(context, judgementCode) {
    return api.getCaseRequestApplicantsByJudgement(judgementCode);
  },
  getCaseRequestApplicant(context, payload) {
    return api['getCaseRequestApplicant'](payload);
  },
  getAddRepresentativeApplicants(context, payload) {
    return api.getAddRepresentativeApplicants(payload.objectKey);
  },
  getCaseSessions(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCaseSessions' : 'getNajizCaseSessions';
    return api[methodName](payload.objectKey);
  },
  getSessionsByRequestObjectKey(context, payload) {
    return api.getSessionsByRequestObjectKey(payload.objectKey);
  },
  getCaseJudgments(context, payload) {
    const methodName = payload.isPega ? 'getIcmsCaseJudgments' : 'getNajizCaseJudgments';
    return api[methodName](payload.objectKey);
  },
  getCaseRequests(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCaseRequests' : 'getNajizCaseRequests';
    return api[methodName](payload.objectKey);
  },
  getWaiverCaseRequests(context, payload) {
    return api.getWaiverCaseRequests(payload);
  },
  getNonCasePartyRequests(context, payload) {
    return api.getNonCasePartyRequests(payload.objectKey);
  },
  getCaseProcedures(context, payload) {
    return api.getIcmsCaseProcedures(payload.objectKey);
  },
  getCaseRelatedProcedure(_context, payload) {
    return api.getCaseRelatedProcedure(payload.objectKey);
  },
  getNonSpecialityAttachmentAcceptanceCriteria(_context, payload) {
    return api.getNonSpecialityAttachmentAcceptanceCriteria(payload);
  },
  getCaseDecisions(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCaseDecisions' : 'getNajizCaseDecisions';
    return api[methodName](payload.objectKey);
  },
  getCaseBasicParties(context, payload) {
    return api[payload.isPega ? 'getIcmsCaseBasicPartiesInfo' : 'getNajizCaseBasicPartiesInfo'](payload);
  },
  getCaseRepresentatives(context, payload) {
    return api[payload.isPega ? 'getIcmsCaseRepresentatives' : 'getNajizCaseRepresentatives'](payload);
  },
  getCasePartiesHaveTravelPreventionDecisions(context, payload) {
    return api[payload.isPega ? 'getIcmsCasePartiesHaveTravelPreventionDecisions' : 'getNajizCasePartiesHaveTravelPreventionDecisions'](payload);
  },
  getCasePartiesHavePrecautionarySeizureOfFundsDecisions(context, payload) {
    return api[payload.isPega ? 'getICMSCasePartiesHavePrecautionarySeizureOfFundsDecisions' : 'getICMSCasePartiesHavePrecautionarySeizureOfFundsDecisions'](payload);
  },
  async getTrustedSourceAttachment(_context, documentId) {
    const res = await api.getTrustedSourceAttachment(documentId);
    return res.data;
  },

  getWrittenPleadingSession(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsWrittenPleadingSession' : 'getNajizWrittenPleadingSession';
    return api[methodName](payload.objectKey, payload.sessionObjectKey);
  },

  getUserCasePartyRoleInCase(context, payload) {
    const methodName = payload.isPega.toString() == 'true' ? 'getIcmsUserCasePartyRoleInCase' : 'getNajizUserCasePartyRoleInCase';
    return api[methodName](payload.objectKey);
  },

  getPublicReplyRequests(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsPublicReplyRequests' : 'getNajizPublicReplyRequests';
    return api[methodName](payload.objectKey);
  },

  getCaseSession(context, payload) {
    const methodName = payload.isPega == 'true' ? 'getIcmsCaseSession' : 'getNajizCaseSession';
    return api[methodName](payload.sessionObjectKey);
  },

  pushArgumentMessage(context, payload) {
    const methodName = payload.isPega == 'true' ? 'pushIcmsArgumentMessage' : 'pushNajizArgumentMessage';
    return api[methodName](payload);
  },

  getDecisions(_context, payload) {
    return api.getDecisions(payload);
  },

  confirmUserAttendance(context, payload) {
    const methodName = payload.isPega == 'true' ? 'confirmIcmsUserAttendance' : 'confirmNajizUserAttendance';
    return api[methodName](payload.objectKey);
  },

  getLawsuitReplyNoteRequest(context, payload) {
    const methodName = payload.isPega ? 'getIcmsLawsuitReplyNoteRequest' : 'getNajizLawsuitReplyNoteRequest';
    return api[methodName](payload.objectKey);
  },

  postRequestPublicReply(context, payload) {
    const methodName = payload.isPega == 'true' ? 'postIcmsRequestPublicReply' : 'postNajizRequestPublicReply';
    return api[methodName](payload);
  },

  validateRequestIssuance(context, payload) {
    return api.validateRequestIssuance(payload);
  },

  IsCaseStoppedOrResume(context, caseObjectKey) {
    return api.IsCaseStoppedOrResume(caseObjectKey);
  },

  getRequestFeesInfo(context, payload) {
    return api.getRequestFeesInfo(payload);
  },

  getCaseBills(_context, caseCode) {
    return api.getCaseBills(caseCode);
  },

  getRequestTypeRequestReasons(context, payload) {
    return api.getRequestTypeRequestReasons(payload);
  },
  getCaseDocuments(context, payload) {
    const methodName = 'getCaseDocuments';
    return api[methodName](payload.objectKey);
  },

  myStatistics(_context) {
    return api.myStatistics();
  },

  checkUserHasValidPermission(context, objectKey) {
    return api.checkUserHasValidPermission(objectKey);
  },

  userHasPermissionCaseRelatedRequest(context, objectKey) {
    return api.userHasPermissionCaseRelatedRequest(objectKey);
  },

  updateCasePartyAttorney(context, payload) {
    return api.updateCasePartyAttorney(payload);
  },

  removeAgencyFromCase(context, payload) {
    return api.removeAgencyFromCase(payload);
  },

  getLawsuitSubjectByCaseCode(_context, caseCode) {
    return api.getLawsuitSubjectByCaseCode(caseCode);
  },

  getLawsuitCaseReplies(_context, caseObjectKey) {
    return api.getLawsuitCaseReplies(caseObjectKey);
  },

  addLawsuitReplyResponseForm(_context, payload) {
    if (payload.responseReplyNote) {
      payload.responseReplyNote = window.btoa(unescape(encodeURIComponent(payload.responseReplyNote)));
    }
    return api.addLawsuitReplyResponseForm(payload);
  },

  validateCaseLawsuitReplyIssuance(_context, caseObjectKey) {
    return api.validateCaseLawsuitReplyIssuance(caseObjectKey);
  },

  validateAttorneyAgainstCaseParties(context, payload) {
    return api.validateAttorneyAgainstCaseParties(payload);
  },
  validateAttorneyTraineeLawyer(context, payload) {
    return api.validateAttorneyTraineeLawyer(payload);
  },

  validationAttendanceRegister(context, sessionObjectKey) {
    return api.validationAttendanceRegister(sessionObjectKey);
  },
  addAttendanceRegisterToSession(context, sessionObjectKey) {
    return api.addAttendanceRegisterToSession(sessionObjectKey);
  },

  getCaseJudges(context, payload) {
    return api.getCaseJudges(payload.objectKey);
  },

  getVideoConference(context, sessionObjectKey) {
    return api.getVideoConference(sessionObjectKey);
  },

  getMyTodaySessions(context) {
    return api.getMyTodaySessions();
  },

  getLitigationAbandonmentDefendants(context, payload) {
    return api.getLitigationAbandonmentDefendants(payload);
  },

  saveLitigationAbandonmentDefendantResponse(context, payload) {
    return api.saveLitigationAbandonmentDefendantResponse(payload);
  },

  getCaseDetails(context, payload) {
    return api.getCaseInfo(payload);
  },
  getCaseTypeRequestTypes(_context, payload) {
    return api.getCaseTypeRequestTypes(payload)
      .then(r => r.data);
  },
  getCaseLawsuitRequests(_context, payload) {
    return api.getCaseLawsuitRequests(payload.objectKey);
  },
  getLawsuitCaseSubject(_context, payload) {
    return api.getLawsuitCase(payload.objectKey);
  },
  attestDabtByParty(context, payload) {
    return api.attestDabtByParty(payload);
  },

  GenerateSessionPdf(context, sessionObjectKey) {
    return api.GenerateSessionPdf(sessionObjectKey);
  },
  CheckUserCanAttest(context, sessionObjectKey) {
    return api.CheckUserCanAttest(sessionObjectKey);
  },
  UserCanAttendSession(context, sessionObjectKey) {
        return api.UserCanAttendSession(sessionObjectKey);
  },
  sendWaiverOfAppealRequestPartyReply(_context, payload) {
    return api.sendWaiverOfAppealRequestPartyReply(payload);
  },
  getWaiverOfAppealRespondents(_context, payload) {
    return api.getWaiverOfAppealRespondents(payload);
  },
  deliverJudgement(_context, payload) {
    return api.deliverJudgement(payload);
  },
  getPegaJudgments(_context, payload) {
    return api.getPegaJudgments(payload);
  },
  getJudgementCodeByObjectKey(_context, payload) {
    return api.getJudgementCodeByObjectKey(payload);
  },
  getJudgementsEligibleForWaiverOfAppeal(_context, payload) {
    return api.getJudgementsEligibleForWaiverOfAppeal(payload);
  },
  getRepresentativesWaiverOfAppeal(_context, payload) {
    return api.getRepresentativesWaiverOfAppeal(payload);
  },
  getIcmsUserRoleFromCasePartyRolesInCase(_context, payload) {
    return api.getIcmsUserRoleFromCasePartyRolesInCase(payload);
  },
  archiveTheCase(_context, payload) {
    return api.archiveTheCase(payload);
  },
  cancelArchivingTheCase(_context, payload) {
    return api.cancelArchivingTheCase(payload);
  },
  generateOtp(_context, payload) {
    return api.generateOtp(payload);
  },
  validateOtp(_context, payload) {
    return api.validateOtp(payload);
  },
  getNearestJudgement(_context, payload) {
    return api.getNearestJudgement(payload);
  },
  isValidApplicantForCommercialJudgement(_context, judgementCode) {
    return api.isValidApplicantForCommercialJudgement(judgementCode);
  },
  isValidVerdictApplicantForCommercialJudgement(_context, judgementCode) {
    return api.isValidVerdictApplicantForCommercialJudgement(judgementCode);
  },
  isJudgementFromCommercialCourt(_context, judgementCode) {
    return api.isJudgementFromCommercialCourt(judgementCode);
  },
  getExecutiveJudgementRespondents(_context, payload) {
    return api.getExecutiveJudgementRespondents(payload);
  },
  getBankAccountsInfo(_context, payload) {
    return api.getBankAccountsInfo(payload);
  },
  sendTanfeethRequest(_context, payload) {
    return api.sendTanfeethRequest(payload);
  },
  getExecutionRequests(_context, payload) {
    return api.getExecutionRequests(payload);
  },
  checkUserHasArchivedCases(_context, payload) {
    return api.checkUserHasArchivedCases(payload);
  },
  getMyArchivedCases(_context, payload) {
    return api.getMyArchivedCases(payload);
  },
  getPortalTypeOfAppealRequest(_context, payload) {
    return api.getPortalTypeOfAppealRequest(payload);
  },
  getJudgementsByRequestObjectKey(_context, payload) {
    return api.getJudgementsByRequestObjectKey(payload);
  },
  isRequestExists(_context, payload) {
    return api.isRequestExists(payload);
  },
    getExecutiveJudgementRequesters(_context, payload) {
        return api.getExecutiveJudgementRequesters(payload);
    },
    getAllJudgementRespondents(_context, payload) {
        return api.getAllJudgementRespondents(payload);
    },
    getExecutionBanks(_context, payload) {
        return api.getExecutionBanks();
    },
  getIncomingRequestDetails(_context, payload) {
    return api.getIncomingRequestDetails(payload);
  },
  getHearingSessions(context, payload) {
    return api.getHearingSessions(payload.objectKey);
  },
  getCorrectionDecisions(_context, caseObjectKey) {
    return api.getCorrectionDecisions(caseObjectKey);
  },
  getAppealRequestJudgementJudgementsAndDecisions(_context, appealRequestJudgementObjectKey) {
    return api.getAppealRequestJudgementJudgementsAndDecisions(appealRequestJudgementObjectKey);
  },
  getCaseSuspensions(_context, caseObjectKey) {
    return api.getCaseSuspensions(caseObjectKey);
  },
  getFirstDegreeJudgement(_context, appealJudgementObjectKey) {
    return api.getFirstDegreeJudgement(appealJudgementObjectKey);
  },
  getLawsuitReport(_context, caseObjectKey) {
    return api.getLawsuitReport(caseObjectKey);
  },
  generateLawsuitPaperPdf(_context, caseObjectKey) {
    return api.generateLawsuitPaperPdf(caseObjectKey);
  },
  saveCassationRequestReply(_context, payload) {
    return api.saveCassationRequestReply(payload);
  },
};